import {IProfileItemModel, ProfileItemModel} from './profile-item.model';
import { LanguageEntry, normalizeToLanguageEntries } from '../constants/language-levels';

export interface Photos {
  photoId?: string;
  thumbnailRef?: string;
  originalRef?: string;
  contentType?: string;
}

export interface ISecurityCheck {
  typ: string;
  submittedOn?: string | Date;
  completedOn?: string | Date;
}

export interface IPersonaldaten extends IProfileItemModel {
  photos?: Photos[]
  intro?: string;
  jahrgang?: string;
  nationalitaet?: string;
  wohnort?: string;
  position?: string;
  hireDate?: Date | string;
  beraterSeit?: string | Date;
  verfuegbar?: Date | string;
  reisebereitschaft?: string;
  sprachen?: LanguageEntry[];
  branchen?: string[];
  schwerpunkte?: string[];
  einschraenkung?: string;
  securityCheck?: ISecurityCheck[];
}

export class Personaldaten extends ProfileItemModel implements IPersonaldaten {
  constructor(
    public photos?: Photos[],
    public intro?: string,
    public jahrgang?: string,
    public nationalitaet?: string,
    public wohnort?: string,
    public position?: string,
    public hireDate?: Date | string,
    public beraterSeit?: string | Date,
    public verfuegbar?: Date | string,
    public reisebereitschaft?: string,
    public sprachen?: LanguageEntry[],
    public branchen?: string[],
    public schwerpunkte?: string[],
    public einschraenkung?: string,
    public securityCheck?: ISecurityCheck[]
  ) {
    super();
    this.photos = photos ? photos : undefined;
    this.intro = intro ? intro : undefined;
    this.jahrgang = jahrgang ? jahrgang : undefined;
    this.nationalitaet = nationalitaet ? nationalitaet : undefined;
    this.wohnort = wohnort ? wohnort : undefined;
    this.position = position ? position : undefined;
    this.beraterSeit = beraterSeit ? beraterSeit : undefined;
    this.verfuegbar = verfuegbar ? verfuegbar : undefined;
    this.reisebereitschaft = reisebereitschaft ? reisebereitschaft : undefined;
    this.sprachen = sprachen ? sprachen : undefined;
    this.branchen = branchen ? branchen : undefined;
    this.schwerpunkte = schwerpunkte ? schwerpunkte : undefined;
    this.einschraenkung = einschraenkung ? einschraenkung : undefined;
  }

  static fromJson(json: IPersonaldaten) {
    const personaldaten = new Personaldaten();
    personaldaten.photos = json.photos;
    personaldaten.intro = json.intro;
    personaldaten.jahrgang = json.jahrgang;
    personaldaten.nationalitaet = json.nationalitaet;
    personaldaten.wohnort = json.wohnort;
    personaldaten.position = json.position;
    const rawEntryDate = (json as any).hireDate ?? json.hireDate;
    personaldaten.hireDate = rawEntryDate ? this.anyToDate(rawEntryDate) : undefined;
    personaldaten.beraterSeit = json.beraterSeit;
    personaldaten.verfuegbar = this.anyToDate(json.verfuegbar);
    personaldaten.reisebereitschaft = json.reisebereitschaft;
    personaldaten.sprachen = normalizeToLanguageEntries(json.sprachen as unknown as string[] | LanguageEntry[]);
    personaldaten.branchen = json.branchen;
    personaldaten.schwerpunkte = json.schwerpunkte;
    personaldaten.einschraenkung = json.einschraenkung;
    return personaldaten;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Personaldaten() as T;
  }
}
